const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')
const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')

const menu = () => import(/* webpackPrefetch: true */ '@/views/private/menu.vue')
const user = () => import(/* webpackPrefetch: true */ '@/views/private/user/index.vue')
const user_detail = () => import(/* webpackPrefetch: true */ '@/views/private/user/_id.vue')
const user_add = () => import(/* webpackPrefetch: true */ '@/views/private/user/add/index.vue')
const user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/user/edit/_id.vue')


const category_user = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/index.vue')
const category_user_add = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/add/index.vue')
const category_user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/edit/_id.vue')


const product = () => import(/* webpackPrefetch: true */ '@/views/private/product/index.vue')
const product_detail = () => import(/* webpackPrefetch: true */ '@/views/private/product/detail/_id.vue')
const product_add = () => import(/* webpackPrefetch: true */ '@/views/private/product/add/index.vue')
const product_edit = () => import(/* webpackPrefetch: true */ '@/views/private/product/edit/_id.vue')


const config = () => import(/* webpackPrefetch: true */ '@/views/private/config/index.vue')

const agenda = () => import(/* webpackPrefetch: true */ '@/views/private/agenda/index.vue')

const hariLibur = () => import(/* webpackPrefetch: true */ '@/views/private/hari-libur/index.vue')

const order = () => import(/* webpackPrefetch: true */ '@/views/private/order/index.vue')
const tandatangan = () => import(/* webpackPrefetch: true */ '@/views/private/tandatangan/index.vue')
const logEsign = () => import(/* webpackPrefetch: true */ '@/views/private/log-esign/index.vue')
const notAllowed = () => import(/* webpackPrefetch: true */ '@/views/private/not-allowed.vue')

const statistik = () => import(/* webpackPrefetch: true */ '@/views/private/statistik/index.vue')

const kategoriBerita = () => import(/* webpackPrefetch: true */ '@/views/private/kategori-berita/index.vue')

const berita = () => import(/* webpackPrefetch: true */ '@/views/private/berita/index.vue')
const berita_detail = () => import(/* webpackPrefetch: true */ '@/views/private/berita/detail/_id.vue')
const berita_add = () => import(/* webpackPrefetch: true */ '@/views/private/berita/add/index.vue')
const berita_edit = () => import(/* webpackPrefetch: true */ '@/views/private/berita/edit/_id.vue')

const banner = () => import(/* webpackPrefetch: true */ '@/views/private/banner/index.vue')

const wa_gateway = () => import(/* webpackPrefetch: true */ '@/views/private/wa-gateway/index.vue')

const penghuniRusunawa = () => import(/* webpackPrefetch: true */ '@/views/private/penghuni-rusunawa/index.vue')
const penghuniRusunawaDetail = () => import(/* webpackPrefetch: true */ '@/views/private/penghuni-rusunawa/detail/_id.vue')

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },

  {
    path: "/profile",
    name: "Profile",
    component: profile,
    meta: {
      title: "Profile"
    }
  },
  {
    path: "/not-allowed",
    name: "Not Allowed",
    component: notAllowed,
    meta: {
      title: "Tidak Diizinkan"
    }
  },

  {
    path: "/menu",
    name: "Menu",
    component: menu,
    meta: {
      title: "Menu"
    }
  },

  {
    path: "/user",
    name: "User",
    component: user,
    meta: {
      title: "User"
    }
  },

  {
    path: "/user/detail/:id",
    name: "User Detail",
    component: user_detail,
    meta: {
      title: "User Detail"
    }
  },

  {
    path: "/user/add",
    name: "User Add",
    component: user_add,
    meta: {
      title: "User Add"
    }
  },

  {
    path: "/user/edit/:id",
    name: "User Edit",
    component: user_edit,
    meta: {
      title: "User Edit"
    }
  },

  {
    path: "/category-user",
    name: "Category User",
    component: category_user,
    meta: {
      title: "Kategori User"
    }
  },

  {
    path: "/category-user/add",
    name: "Category User Add",
    component: category_user_add,
    meta: {
      title: "Tambah Kategori User"
    }
  },

  {
    path: "/category-user/edit/:id",
    name: "Category User Edit",
    component: category_user_edit,
    meta: {
      title: "Ubah Kategori User"
    }
  },
  {
    path: "/agenda",
    name: "Agenda",
    component: agenda,
    meta: {
      title: "Agenda"
    }
  },
  {
    path: "/order",
    name: "Pemakaian / Penggunaan",
    component: order,
    meta: {
      title: "Pemakaian / Penggunaan"
    }
  },
  {
    path: "/tandatangan",
    name: "Tanda Tangan",
    component: tandatangan,
    meta: {
      title: "Tanda Tangan"
    }
  },
  {
    path: "/log-esign",
    name: "Log E-Sign",
    component: logEsign,
    meta: {
      title: "Log E-Sign"
    }
  },
  {
    path: "/hari-libur",
    name: "Hari Libur",
    component: hariLibur,
    meta: {
      title: "Hari Libur"
    }
  },
  {
    path: "/config",
    name: "Config",
    component: config,
    meta: {
      title: "Config"
    }
  },



  {
    path: "/product",
    name: "Fasilitas Umum",
    component: product,
    meta: {
      title: "Fasilitas Umum"
    }
  },

  {
    path: "/product/detail/:id",
    name: "Fasilitas Umum Detail",
    component: product_detail,
    meta: {
      title: "Fasilitas Umum Detail"
    }
  },

  {
    path: "/product/add",
    name: "Fasilitas Umum Add",
    component: product_add,
    meta: {
      title: "Fasilitas Umum Add"
    }
  },

  {
    path: "/product/edit/:id",
    name: "Fasilitas Umum Edit",
    component: product_edit,
    meta: {
      title: "Fasilitas Umum Edit"
    }
  },

  {
    path: "/statistik",
    name: "Statistik",
    component: statistik,
    meta: {
      title: "Statistik"
    }
  },

  {
    path: "/kategori-berita",
    name: "Kategori Berita",
    component: kategoriBerita,
    meta: {
      title: "Kategori Berita"
    }
  },

  {
    path: "/berita",
    name: "Berita",
    component: berita,
    meta: {
      title: "Berita"
    }
  },

  {
    path: "/berita/detail/:id",
    name: "Berita Detail",
    component: berita_detail,
    meta: {
      title: "Detail Berita"
    }
  },

  {
    path: "/berita/add",
    name: "Berita Add",
    component: berita_add,
    meta: {
      title: "Tambah Berita"
    }
  },

  {
    path: "/berita/edit/:id",
    name: "Berita Edit",
    component: berita_edit,
    meta: {
      title: "Ubah Berita"
    }
  },

  {
    path: "/banner",
    name: "Banner",
    component: banner,
    meta: {
      title: "Banner"
    }
  },

  {
    path: "/wa-gateway",
    name: "WA Gateway",
    component: wa_gateway,
    meta: {
      title: "WA Gateway"
    }
  },

  {
    path: "/penghuni-rusunawa",
    name: "Penghuni Rusunawa",
    component: penghuniRusunawa,
    meta: {
      title: "Penghuni Rusunawa"
    }
  },

  {
    path: "/penghuni-rusunawa/detail/:id",
    name: "Detail Penghuni Rusunawa",
    component: penghuniRusunawaDetail,
    meta: {
      title: "Detail Penghuni Rusunawa"
    }
  },
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})